/**
 * ScrollToTop — mounts once inside <BrowserRouter> and resets window.scrollY to 0
 * whenever the pathname changes so newly-opened routes always start at the top.
 *
 * Two exceptions preserve UX:
 *  1. In-page anchor navigation (URL has a `hash`) — respect the anchor scroll.
 *  2. Browser back/forward (POP action) — respect the browser's own scroll restoration.
 */
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType(); // "PUSH" | "REPLACE" | "POP"

  useEffect(() => {
    if (hash) return; // let the browser handle #anchors
    if (navType === "POP") return; // don't fight back/forward
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash, navType]);

  return null;
}
